// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_4C55z"};